import { ApiPost } from '../util/axios'
import { consoleLog } from '../util'

const getOrganizationAggregationKeywordsApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywords',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordsResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordNotesApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordNotes',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordNotesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordTypesApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordTypes',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordTypesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordSubTypesApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordSubTypes',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordSubTypesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setOrganizationAggregationNonSearchKeywordApi = async data => {
  const options = {
    reqId: 'SetOrganizationAggregationNonSearchKeyword',
    payload: data,
    resId: 'SetOrganizationAggregationNonSearchKeywordResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setOrganizationAggregationKeywordNotesApi = async data => {
  const options = {
    reqId: 'SetOrganizationAggregationKeywordNotes',
    payload: data,
    resId: 'SetOrganizationAggregationKeywordNotesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setOrganizationAggregationKeywordTypeApi = async data => {
  const options = {
    reqId: 'SetOrganizationAggregationKeywordType',
    payload: data,
    resId: 'SetOrganizationAggregationKeywordTypeResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setOrganizationAggregationKeywordSubTypeApi = async data => {
  const options = {
    reqId: 'SetOrganizationAggregationKeywordSubType',
    payload: data,
    resId: 'SetOrganizationAggregationKeywordSubTypeResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordDetailsApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordDetails',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordDetailsResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getItemsAnalyzedPerKeywordCountApi = async data => {
  const options = {
    reqId: 'GetItemsAnalyzedPerKeywordCount',
    payload: data,
    resId: 'GetItemsAnalyzedPerKeywordCountResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordDetailsCountApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordDetailsCount',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordDetailsCountResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setOrganizationAggregationKeywordMapApi = async data => {
  const options = {
    reqId: 'SetOrganizationAggregationKeywordMap',
    payload: data,
    resId: 'SetOrganizationAggregationKeywordMapResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    // consoleLog('error - ', error)
    return error
  })
}

const getOrganizationAggregationSubKeywordDetailsApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationSubKeywordDetails',
    payload: data,
    resId: 'GetOrganizationAggregationSubKeywordDetailsResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setOrganizationAggregationSubKeywordsApi = async data => {
  const options = {
    reqId: 'SetOrganizationAggregationSubKeywords',
    payload: data,
    resId: 'SetOrganizationAggregationSubKeywordsResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationSubKeywordDetailsCountApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationSubKeywordDetailsCount',
    payload: data,
    resId: 'GetOrganizationAggregationSubKeywordDetailsCountResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

export default {
  getOrganizationAggregationKeywordsApi,
  getOrganizationAggregationKeywordNotesApi,
  getOrganizationAggregationKeywordTypesApi,
  getOrganizationAggregationKeywordSubTypesApi,

  setOrganizationAggregationNonSearchKeywordApi,
  setOrganizationAggregationKeywordNotesApi,
  setOrganizationAggregationKeywordTypeApi,
  setOrganizationAggregationKeywordSubTypeApi,

  getOrganizationAggregationKeywordDetailsApi,
  getItemsAnalyzedPerKeywordCountApi,
  getOrganizationAggregationKeywordDetailsCountApi,
  setOrganizationAggregationKeywordMapApi,

  getOrganizationAggregationSubKeywordDetailsApi,
  setOrganizationAggregationSubKeywordsApi,
  getOrganizationAggregationSubKeywordDetailsCountApi
}
